<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<style src="@/assets/css/load.css" lang="css"></style>
<style src="@/assets/css/table.css" lang="css"></style>
<style src="vue-select/dist/vue-select.css"></style>

<script>
export default {
  name: 'app'
}
</script>
